import { z } from 'zod';

export type ImageUpload = z.infer<typeof imageUploadSchema>;

export const imageUploadSchema = z.object({
  imageUrl: z.string(),
  imageUploadUrl: z.string(),
});
